import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { GlobalFactory } from './presentation/global/global-factory';
import { Document, Page ,pdfjs} from 'react-pdf';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { theme } from './theme';

const root = ReactDOM.createRoot(

  document.getElementById('root') as HTMLElement
);

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <GlobalFactory>
      <BrowserRouter>
        <div style={{ width: '100%', height: '100%' }}>
          <App />
        </div>
      </BrowserRouter>
    </GlobalFactory>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
